import React from "react";
import "../templet1/Templet1.css";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../Components/loading";
import {
  BalloonContainer,
  FadeInElement,
  ZoomInElement,
} from "../../Components/animations";
import MapComponent from "../../Components/MapComponent";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL  as api} from "../../services";


const Templet1 = ({ profileData, setTheme }) => {
  const { name } = useParams();
  const [result, setResult] = useState("  ");
  const [mname, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [bday, setBday] = useState();
  const [bmonth, setBmonth] = useState();
  const location = useLocation();
  const currentRoute = location.pathname;
  useEffect(() => {
    profile();
  });

  const profile = async () => {
    try {
      if (!profileData) {
        window.location.href = "/";
      } else {
        setResult(profileData);
        const [, fetchedBmonth, fetchedBday] = profileData?.DOB.split("-");
        setBmonth(fetchedBmonth);
        setBday(fetchedBday);
        setFavicon(profileData?.Photo);
        document.title = profileData?.Name;
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      // Handle the error here, e.g., show an error message to the user
    } finally {
      // Move setLoading into the finally block to ensure it's called regardless of success or failure
      setLoading(false);
    }
  };

  function setFavicon(url) {
    const faviconLink = document.createElement("link");
    faviconLink.rel = "icon";
    faviconLink.href = url;

    // Remove existing favicon links before appending the new one
    const existingFavicons = document.querySelectorAll("link[rel='icon']");
    existingFavicons.forEach((favicon) => favicon.remove());

    document.head.appendChild(faviconLink);
  }

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const openPdf = (pdfUrl) => {
    // Open the PDF in a new window or tab
    window.open(pdfUrl, "_blank");
  };

  const SendMail = async () => {
    if (email && mname && message) {
      try {
        const response = await axios.post(api + "/sendMail", {
          name,
          message,
          mname,
          email,
          Email:result.Email
        });
  
        if (response.data) {
          toast.success("Email sent successfully.");
          setName("");
          setEmail("");
          setMessage("");
        } else {
          toast.error(response.data.error || "Failed to send email.");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while sending the email. Please try again.");
      }
    } else {
      toast.error("Please enter your name, email, and message to send an email.");
    }
  };
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;

  return (
    <>
      <LoadingSpinner state={loading} />
      <BalloonContainer
        show={
          parseInt(bday) === parseInt(day) &&
          parseInt(month) === parseInt(bmonth)
        }
        birthdayPerson={result.Name}
      />
      <nav className="navbar navbar-expand-lg navbar-bottom-line" id="nav-bg">
        <div className="container-fluid ms-md-5 me-md-5 ms-3 me-3">
          {/* Replace text with logo image */}
          <a className="navbar-brand active" href="#home">
            {result ? result.Name : "Loading..."}
          </a>
          {/* End of logo image */}
          {/* Add Bootstrap responsive CSS classes */}
          <button
            className="navbar-toggler navbar-toggler-custom"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#projects">
                  Projects
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#skills">
                  Skills
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#exprerience">
                  Exprerience
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="theme darktheme">
        <button onClick={() => setTheme("dark")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-moon-stars-fill"
            viewBox="0 0 16 16"
          >
            <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278" />
            <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.73 1.73 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.73 1.73 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.73 1.73 0 0 0 1.097-1.097zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" />
          </svg>
        </button>
      </div>
      <div className="container"></div>
      <div className="container home-div">
        <div
          className="row justify-content-center align-items-center"
          id="intro"
        >
          <div className="col-md-6 order-md-2 p-md-left-10 p-3" id="intro-text">
            <div className="profile-img-container wavy-circle">
              {" "}
              {/* Added a container for the circular frame */}
              <ZoomInElement>
                <img
                  src={
                    result.Photo
                      ? result.Photo
                      : `https://portfolionom.vercel.app/Profile.png`
                  }
                  alt={result.Name}
                  className="profile-img"
                  loading="lazy"
                />{" "}
              </ZoomInElement>
              {/* Use correct class name */}
            </div>
          </div>
          <div className="col-md-6 order-md-1">
            <h1 className="display-6 fw-bold text-dark lh-1 mb-3 ">
              Hello, I'm{" "}
              {result ? (
                <div className="typewriter">
                  {" "}
                  <span className="gradient-text">{result.Name}</span>{" "}
                </div>
              ) : (
                "Loading..."
              )}
            </h1>
            <p className="sub-text">
              Detail-oriented college student with a strong enthusiasm for
              acquiring hands-on experience and utilizing technical skills.
              Eager to secure internship opportunities to further professional
              growth and contribute to impactful projects.
            </p>
            <div className="d-grid gap-2 d-md-flex justify-content-md-start mb-2">
              {result && result.Resume && (
                <button
                  type="button"
                  className="btn card-button"
                  onClick={() => openPdf(result && result.Resume)}
                >
                  Resume
                </button>
              )}
            </div>
            <div className="social-logos d-flex gap-4 d-md-flex justify-content-md-start">
              {result && result.Instagram && (
                <ZoomInElement>
                  <a
                    href={`https://instagram.com/${
                      result ? result.Instagram : ""
                    }`}
                    target="_blank"
                    rel="noreferrer"
                    className="social-logo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="2em"
                      viewBox="0 0 448 512"
                      fill="black"
                    >
                      <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                    </svg>
                  </a>
                </ZoomInElement>
              )}{" "}
              {result && result.Facebook && (
                <ZoomInElement>
                  <a
                    href={`https://facebook.com/${
                      result ? result.Facebook : ""
                    }`}
                    rel="noreferrer"
                    target="_blank"
                    className="social-logo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="2em"
                      viewBox="0 0 448 512"
                      fill="black"
                    >
                      <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
                    </svg>
                  </a>
                </ZoomInElement>
              )}
              {result && result.Github && (
                <ZoomInElement>
                  <a
                    href={`https://github.com/${result ? result.Github : ""}`}
                    rel="noreferrer"
                    target="_blank"
                    className="social-logo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="2em"
                      viewBox="0 0 496 512"
                      fill="black"
                    >
                      <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                    </svg>
                  </a>
                </ZoomInElement>
              )}{" "}
              {result && result.LinkedIn && (
                <ZoomInElement>
                  <a
                    href={result ? result.LinkedIn : ""}
                    target="_blank"
                    rel="noreferrer"
                    className="social-logo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="2em"
                      viewBox="0 0 448 512"
                      fill="black"
                    >
                      <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                    </svg>
                  </a>
                </ZoomInElement>
              )}{" "}
              {result && result.PhoneNumber && (
                <ZoomInElement>
                  <a
                    href={`https://wa.me/91${result.PhoneNumber}`}
                    target="_blank"
                    rel="noreferrer"
                    className="social-logo"
                  >
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="2em"
                      viewBox="0 0 448 512"
                      fill="black"
                    >
                      <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
                    </svg>
                  </a>
                </ZoomInElement>
              )}
            </div>
          </div>
        </div>
      </div>
      <hr className="custom-line" id="projects" />
      <div className="container project-div">
        <div className="container mt-5">
          <h2 className="text-center main-heading">Projects</h2>
          <p className="text-center sub-text">
            Discover a collection of my varied projects, encompassing web
            development and beyond. These endeavors demonstrate my abilities,
            imagination, and dedication to providing top-notch solutions.
            Whether it's responsive websites or inventive applications, each
            project narrates a distinct tale of problem-solving and exceptional
            work..
          </p>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
            {result?.Projects?.length > 0 ? (
              result.Projects.map(
                (project, index) =>
                  project.title !== "" && (
                    <div key={index}>
                      <FadeInElement>
                        <div className="col mb-4">
                          <div className="card cards h-100 d-flex flex-column">
                            <img
                              src="./project_light.png"
                              className="card-img-top"
                              alt={project.title}
                            />
                            <div className="card-body d-flex flex-column">
                              <h5 className="card-title"> {project.title}</h5>
                              <p className="card-text">
                                {expanded
                                  ? project.description
                                  : project.description.slice(0, 100)}
                                {project.description.length > 100 && (
                                  <button
                                    variant="link"
                                    className="text-dark btn btn-sm "
                                    onClick={() => setExpanded(!expanded)}
                                  >
                                    {expanded ? "Show Less" : "Read More"}
                                  </button>
                                )}
                              </p>
                              <a
                                href={project.link}
                                className="btn card-button mt-auto"
                                target="_blank"
                                rel="noreferrer"
                              >
                                View Project
                              </a>
                            </div>
                          </div>
                        </div>
                      </FadeInElement>
                    </div>
                  )
              )
            ) : (
              <p className="text-light">No Projects available</p>
            )}
          </div>
        </div>
      </div>
      <hr className="custom-line" id="skills" />
      <div className="container skill-div">
        <div id="skills" className="container mt-5">
          <h2 className="text-center main-heading">Skills & Technologies</h2>
          <p className="text-center sub-text">
            Explore my wide range of skills and expertise in the latest
            technologies. From web development frameworks to programming
            languages, I possess a versatile skill set. These capabilities
            empower me to address various challenges, ensuring I am
            well-prepared to provide creative solutions and lead projects to
            successful outcomes.
          </p>
          <div className="row justify-content-center">
            {result?.Skills?.length > 0 ? (
              result.Skills.map(
                (skill) =>
                  skill !== "" && (
                    <div className="col-lg-3 col-md-3 col-sm-3 mb-4">
                      <ZoomInElement>
                        <div className="card cards">
                          <div className="card-body">
                            <span>★</span> {/* Checkmark symbol */}
                            {skill}
                          </div>
                        </div>
                      </ZoomInElement>
                    </div>
                  )
              )
            ) : (
              <p className="text-light">No skills available</p>
            )}
          </div>
        </div>
      </div>
      <hr className="custom-line" id="exprerience" />
      <div className="container project-div">
        <div className="container mt-5">
          <h2 className="text-center main-heading">
            Exprerience & Certifications
          </h2>
          <p className="text-center sub-text">
            Discover my technological journey and unwavering dedication to
            ongoing education. This section presents my professional endeavors,
            emphasizing the projects and positions that have influenced my
            career. Furthermore, you'll encounter certifications that affirm my
            competence and determination to remain current in this dynamic
            industry.
          </p>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
            {result?.Certifications?.length > 0 ? (
              result.Certifications.map(
                (certificate, index) =>
                  certificate.title !== "" && (
                    <div key={index}>
                      <FadeInElement>
                        <div className="col mb-4">
                          <div className="card cards h-100 d-flex flex-column">
                            <img
                              src="./certificate.jpg"
                              className="card-img-top"
                              alt={certificate.title}
                            />
                            <div className="card-body d-flex flex-column">
                              <div
                                style={{
                                  position: "absolute",
                                  top: "28%",
                                  left: "51%",
                                  transform: "translate(-50%, -50%)",
                                }}
                              >
                                <h5 className="text-success ">
                                  {certificate.title.toUpperCase()}
                                </h5>
                              </div>
                              <h5 className="card-title">
                                {" "}
                                {certificate.title}
                              </h5>
                              <p className="card-text">
                                {expanded
                                  ? certificate.description
                                  : certificate.description.slice(0, 100)}
                                {certificate.description.length > 100 && (
                                  <button
                                    variant="link"
                                    className="text-dark btn btn-sm btn-link"
                                    onClick={() => setExpanded(!expanded)}
                                  >
                                    {expanded ? "Show Less" : "Read More"}
                                  </button>
                                )}
                              </p>
                              <a
                                href={certificate.link}
                                className="btn card-button mt-auto"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Certificate Link
                              </a>
                            </div>
                          </div>
                        </div>
                      </FadeInElement>
                    </div>
                  )
              )
            ) : (
              <p className="text-light">No Certifications available</p>
            )}
          </div>
        </div>
      </div>
      <hr className="custom-line" id="contact" />
      <div className="container contact-div">
        <div id="contact" className="container mt-5">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <MapComponent address={result.Address} pincode={result.Pincode} />
            </div>
            <div className="col-md-6">
              <div className="card cards">
                <div className="card-body">
                  <h3>Your Next Team Member Awaits</h3>
                  <div>
                    <input
                      type="hidden"
                      name="csrfmiddlewaretoken"
                      defaultValue="oO4RuxaOHfUbxREnpVyBwrAQJLiBr8ZGP1XbGrJgOocEzR8TTJUyKfw5aTHyFRDE"
                    />
                    <div id="div_id_name" className="mb-3">
                      {" "}
                      <label
                        htmlFor="id_name"
                        className="form-label requiredField"
                      >
                        Name
                      </label>{" "}
                      <input
                        type="text"
                        name="name"
                        maxLength={200}
                        className="textinput form-control"
                        id="name"
                        placeholder="Your Name"
                        value={mname}
                        onChange={handleNameChange}
                        required
                      />{" "}
                    </div>{" "}
                    <div id="div_id_email" className="mb-3">
                      {" "}
                      <label
                        htmlFor="id_email"
                        className="form-label requiredField"
                      >
                        Email
                      </label>{" "}
                      <input
                        type="email"
                        name="email"
                        maxLength={254}
                        className="emailinput form-control"
                        id="mailId"
                        placeholder="name@example.com"
                        value={email}
                        onChange={handleEmailChange}
                        required
                      />{" "}
                    </div>{" "}
                    {/* <div id="div_id_subject" className="mb-1">
                      {" "}
                      <label htmlFor="id_subject" className="form-label">
                        Subject
                      </label>{" "}
                      <input
                        type="text"
                        name="subject"
                        maxLength={200}
                        className="textinput form-control"
                        id="id_subject"
                      />{" "}
                    </div>{" "} */}
                    <div id="div_id_message" className="mb-3">
                      {" "}
                      <label
                        htmlFor="id_message"
                        className="form-label requiredField"
                      >
                        Message
                      </label>{" "}
                      <textarea
                        name="message"
                        cols={40}
                        rows={4}
                        className="textarea form-control"
                        id="message"
                        placeholder="Your Message"
                        value={message}
                        onChange={handleMessageChange}
                        required
                      />{" "}
                    </div>
                    <button onClick={SendMail} className="btn card-button">
                      Hire Me
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container footer ">
      <footer className="d-flex flex-wrap justify-content-between align-items-center py-2 border-top border-1">
        <div className="col-md-2 d-flex align-items-center">
          <a
            href="/"
            className="mb-1 mb-md-0 text-body-secondary text-decoration-none lh-1"
          >
            <img
              className="bi"
              width={40}
              height={40}
              src="./myport.png"
              alt="logo"
            />
          </a>
          <span className="mb-1 mb-md-0 footer-data ">
             <b>© 2023 My Portfolio, Inc</b>
          </span>
        </div>

        <div className="footer-data">
          {currentRoute === ("/" || "/signup") ? (
            ""
          ) : (
            <>
              Ready to showcase your skills?{" "}
              <a href="/">Create your portfolio</a> now!
            </>
          )}
          {currentRoute === "/" || currentRoute === "/signup" ? (
            <>
            
              <p className="text-center mb-1 mb-md-0">
                This web application was developed and designed by the AR team (
                <a href="/anilreddykota" className="footer-data">
                  Anil Reddy
                </a>{" "}
                &{" "}
                <a href="/ramsaiandhavarapu" className="footer-data">
                  Ramsai
                </a>
                ){" "}
              </p>
            </>
          ) : null}
        </div>

        <ul className="nav justify-content-end list-unstyled d-flex">
          <li className="ms-3">
            <a className="footer-data" href="/anilreddykota">
              <i className="fa-brands fa-instagram"></i>
            </a>
          </li>
          <li className="ms-3">
            <a className="footer-data" href="/anilreddykota">
              <i className="fa-brands fa-facebook"></i>
            </a>
          </li>
          <li className="ms-3">
            <a className="footer-data" href="/ramsaiandhavarapu">
              <i className="fa-brands fa-twitter"></i>
            </a>
          </li>
        </ul>
      </footer>
    </div>
    </>
  );
};

export default Templet1;
